import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  hasMerchant: boolean = true;
  merchant: string = '';

  ngOnInit() {
    let _ = this;
    _.validateMerchant();
  }

  validateMerchant(){
    let _ = this;
    let url: any = location.href.split('/');
    url = url[3];
    _.merchant = url;
    if(url == ''){
      _.hasMerchant = false;
    }
  }
}
